import { useRef, useState } from "react";
import Button from "../../gui/Button/Button";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import Form, { useForm } from "../../gui/Form/Form";
import Validators from "../../gui/Form/Validators";
import FormControl from "../../gui/Form/FormControl";
import TextInput, { ITextInput } from "../../gui/TextInput/TextInput";
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider";
import Dirs from "../../fmanlibs/Dirs";
import Files from "../../fmanlibs/Files";

const DIALOG_ID = "newFile"
export default function NewFileDlg(props:{parentId:string, isFile:boolean}){
    const {popOverlay} = useOverlay()
    const [busy,setBusy] = useState<boolean>(false)
    const filename = useRef<ITextInput|null>(null)
    const {valid} = useForm()
    const {addSnackbar} = useSnackbar()

    const onClose = () => popOverlay(DIALOG_ID)
    const onSave = async () => {
        if (busy) return
        else setBusy(true)
        try {
            if (props.isFile) await Files.i.createSession(props.parentId, filename.current!.value!, 0, "none")
            else {
                await Dirs.i.createPath(props.parentId, filename.current!.value!)
                // await Dirs.i.expire().get()
            }
            await Files.i.expire(props.parentId).get(props.parentId)
            onClose()
        }catch(e){
            addSnackbar(e)        
        }finally{
            setBusy(false)
        }
    }
    const type = props.isFile ? "Text Document" : "Folder"
    const placeholder = props.isFile ? "Document name" : "Folder name"
    return <>
        <div className="header"><h2>New {type}</h2></div>
        <div className="content">
            <FormControl validators={[Validators.Required(type)]}>
                <TextInput placeholder={placeholder} float={true} ref={filename}/>
            </FormControl>
        </div>
        <div className="actions">
            <Button size="medium" onClick={onClose}>Cancel</Button>
            <Button size="medium" disabled={!valid || busy} onClick={onSave}>Create</Button>
        </div>
    </>
}

export function useNewFileDlg(){
    const {hasOverlay,addOverlay} = useOverlay()
    const openNewFile = (parentId:string, isFile:boolean) => {
        if (hasOverlay(DIALOG_ID)) return
        else addOverlay(DIALOG_ID, {children:<Form><NewFileDlg parentId={parentId} isFile={isFile}/></Form>, className:"dialog"})
    }
    return {openNewFile}
}